module.exports = __webpack_public_path__ + "img/sq_header_milovat_pohyb.d6ed8614.jpg";